import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 86145497-4CAA-41D6-A14E-0DD3FEE7721E
 * name arrange-send-to-back
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrange-send-to-back.svg
 * tags
 * - Arrange 
 * - Geographic Information System 
 */
export const ArrangeSendToBackIcon = createSvgIcon(<><path d="M2,2H11V11H2V2M9,4H4V9H9V4M22,13V22H13V13H22M15,20H20V15H15V20M16,8V11H13V8H16M11,16H8V13H11V16Z" /></>, 'ArrangeSendToBackIcon');
export default ArrangeSendToBackIcon